import { reactive, readonly } from 'vue';

import { ChatUIContext, ChatUIState } from '@/types/components';

export function useChatUI(): ChatUIContext {
  /* state */
  const state = reactive<ChatUIState>({
    isVisibleDm: false, // "DM"
    isVisibleMCSPController: false, // "전문가용 멀티 채널 지원 보기"
    isVisibleMCSController: false, // "멀티 채널 지원 보기"
    isVisibleMicSecretController: false, // "마이크 컨트롤러 보기"
    isVisibleButtonMyLanguage: false, // "나의 언어만 보기"
    isVisibleSecretLangaugeChange: false, // "테스터 전용 컨트롤러"
  });

  /* actions */
  const toggleDm = () => {
    state.isVisibleDm = !state.isVisibleDm;
  };
  const toggleMCSPController = () => {
    state.isVisibleMCSPController = !state.isVisibleMCSPController;
  };
  const toggleMCSController = () => {
    state.isVisibleMCSController = !state.isVisibleMCSController;
  };
  const toggleMicSecretController = () => {
    state.isVisibleMicSecretController = !state.isVisibleMicSecretController;
  };
  const toggleButtonMyLanguage = () => {
    state.isVisibleButtonMyLanguage = !state.isVisibleButtonMyLanguage;
  };
  const toggleSecretLangaugeChange = () => {
    state.isVisibleSecretLangaugeChange = !state.isVisibleSecretLangaugeChange;
  };

  return {
    state: readonly(state),
    actions: {
      toggleDm,
      toggleMCSController,
      toggleMCSPController,
      toggleButtonMyLanguage,
      toggleSecretLangaugeChange,
      toggleMicSecretController,
    },
  };
}
